<template>
  <section :class="$style.container">
    <Wrapper :class="$style.inner">
      <RichText :text-params="primary.text" :class="$style.text" />
      <ArrowButton
        v-if="primary.cta_text"
        is-outlined
        :href="getFormatedLink(primary.cta_link)"
        :class="$style.cta"
      >
        {{ primary.cta_text }}
      </ArrowButton>
    </Wrapper>
  </section>
</template>

<script>
import ArrowButton from '~/components/ArrowButton'
import { getFormatedLink } from '~/mixins/getFormatedLink'
export default {
  name: 'BottomBanner',
  components: { ArrowButton },
  mixins: [getFormatedLink],
  props: {
    slice: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      primary: this.slice.primary,
      items: this.slice.items,
    }
  },
}
</script>

<style lang="scss" module>
.container {
  padding: 160px 60px;

  text-align: center;
  @include below(small) {
    padding: 80px 30px;
  }
}
.inner {
}
.text {
  h2 {
    font-weight: 200;
    font-size: 48px;
    line-height: 55px;
  }
  p {
    @include typo-headline-bold;
    margin-top: 16px;
  }
}
.cta {
  margin-top: 40px;
}
</style>
